import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_28_3 implements Validator {

    public static id = 'CTRL_28_3';
    private message = 'error.ctr_28';


    public LOG: LogService = new LogService(CTRL_28_3);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_28_3.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const critereLibreNameWithStepId = map.get(ctrl.value.rgCtrls.critereLibre);
                const critereLibreCtrl = form.controls[critereLibreNameWithStepId];

                if (critereLibreCtrl.value?.length > 1) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
